import Cookies from 'js-cookie';

function initPoll() {
$('.poll--card').each(function () {
    var thisCard = $(this);

    thisCard.find('.confirm').on('click', function(){

        thisCard.addClass('confirmed');

        var pollID = thisCard.data('poll');
        var post_id = thisCard.data('id');
        var next = thisCard.data('next');
        var polltype = thisCard.data('type');
        if(polltype=='stars') {
            var star_result = $('input[name="rate"]:checked').val();
            var real_result = {
                5: 1,
                4: 2,
                3: 3,
                2: 4,
                1: 5
            }
            var result = real_result[star_result];
        }
        else {
            var result = $('input[name="'+pollID+'"]:checked').val();
            var nextQ = parseInt($('input[name="'+pollID+'"]:checked').data('next'));
            if(nextQ && nextQ > 0) {
                next = nextQ;
            }
        }
        var rushCookie = Cookies.get('targetRush');
        if(rushCookie) {
            var cookieObj = JSON.parse(rushCookie);
        }
        else {
            var cookieObj = {};
        }
        cookieObj[pollID] = result;
        console.log(pollID,result);
        cookieObj['nextQuestion'] = next;
        var cookieStr = JSON.stringify(cookieObj);
        Cookies.set('targetRush',cookieStr);
        var data = {
            action: 'vote_action',
            id: post_id,
            vote: result,
            type: polltype
        };
        //console.log(data);
        $.post('/wp-admin/admin-ajax.php', data, function(response) {
            if(polltype == 'multi') {
                var sum = parseInt($('div.poll--card[data-poll="'+pollID+'"] div#poll_result').data('sum')) + 1;
                $('div.poll--card[data-poll="'+pollID+'"] .result--bar').each(function() {
                    let current_result = $(this).data('result' );
                    if(result == $(this).data('index')) {
                        current_result++;
                        $(this).data('result',current_result);
                    }
                    if(current_result > 0) {
                        var percent_result = 100 / sum * parseInt(current_result);              
                        var result_round = Math.round(percent_result * 10) / 10;
                    }
                    else {
                        var result_round = 0;
                    }
                    $(this).css('--resultwidth',result_round+"%");
                    $(this).next().find('span.result--width').html(result_round+"%");
                });
            }
            else {
                var stars = {};
                $('div.poll--card[data-poll="'+pollID+'"] input.star').each(function() {
                    console.log($(this).val(),$(this).data('rating'));
                    stars[$(this).val()] = $(this).data('rating');
                    if(result == $(this).val()) {
                        stars[$(this).val()]++;
                        $(this).data('rating', stars[$(this).val()]);
                    }
                });
                console.log(stars);
                var average = (5*stars[5] + 4*stars[4] + 3*stars[3] + 2*stars[2] + 1*stars[1]) / (stars[1] + stars[2] + stars[3] + stars[4] + stars[5]);
                console.log('avg',average);
                var star_rating_checked = Math.floor(average) + 1;
                var avg_percent = Math.round(average*10) / 10;
                console.log('checked',star_rating_checked);
                console.log('avg percent',avg_percent);
                var current_star = star_rating_checked + 1;
                var current_star_filling = (avg_percent - star_rating_checked) * 100;
                console.log('currentstar',current_star_filling);

                $('div.poll--card[data-poll="'+pollID+'"] .star').each(function() {
                    if($(this).data('star') <= star_rating_checked) {
                        $(this).removeClass('current-rating').addClass('checked--star');
                    }
                    else {
                        $(this).removeClass('current-rating').removeClass('checked--star');
                    }
                });
                $('div.poll--card[data-poll="'+pollID+'"] .star'+star_rating_checked).addClass('current-rating');
                if(current_star_filling > 0 && current_star < 6) {
                    $('div.poll--card[data-poll="'+pollID+'"] #star'+current_star).addClass('current-rating');
                    $('div.poll--card[data-poll="'+pollID+'"] #starlabel'+current_star).css('--rating',current_star_filling+'%');
                }
                $('div.poll--card[data-poll="'+pollID+'"] span.average').html(avg_percent);
            }
         });
    })

});

$('.rate input, .poll--multiple input').change(function() {
    $(this).closest('.poll--card').find('.poll--footer--confirm button').each(function() {
        $(this).attr('disabled',false);
        $(this).addClass('btn--active');
    });
})

}

if($('#poll_right')) {
    var cookie_options = [];
    var poll_container = $('#poll_right');
    var poll = poll_container.data('poll');
    var opt = 'opt_KMU';
    if(poll == 'series') {
        var rushCookie = Cookies.get('targetRush');
        if(rushCookie) {
            var cookieObj = JSON.parse(rushCookie);
            console.log(cookieObj);
            if(cookieObj.nextQuestion) {
                console.log('next',cookieObj.nextQuestion);
                poll = cookieObj.nextQuestion;
            }
            else {
                if(cookieObj.option_cookie) {
                    console.log('opt',cookieObj.option_cookie);
                    opt = cookieObj.option_cookie;
                    poll = cookie_options[opt];
                    console.log(cookieObj,cookieObj[poll]);
                    // Wurde bereits beantwortet
                    if(cookieObj[poll]) {
                        poll = false;
                    }
                }
            }
        }
        else {
            poll = cookie_options[opt];
        }
    }
    console.log('poll',poll);

    if(Number.isInteger(poll)) {
        var data = {
            action: 'poll_action',
            id: poll
        };
        $.post('/wp-admin/admin-ajax.php', data, function(response) {
            $('#poll_right').html(response);
            initPoll();
        });
    }
}